import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ProjectSetupAPI = createApi({
  reducerPath: "ProjectSetup",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}`,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getFloorplans: builder.query({
      query: ({ id }) => `/floorplans/${id}`,
    }),
  }),
});

export const { useGetFloorplansQuery } = ProjectSetupAPI;
